import { ProductTypes } from "./ProductTypes";

export const ProductSections = {
  [ProductTypes.COLLECTION]: "collections",
  [ProductTypes.EQUIPMENT]: "equipment",
  [ProductTypes.LEARNING_KIT]: "learningKits",
  [ProductTypes.ONLINE_COURSE]: "onlineCourse",
  [ProductTypes.MATERIALS]: "materials"
};
